import { Container } from 'beam';
import CubicBezier from './helpers/cubicBezier';
import Box from './Box';

export default class GLSteppedScrollSection extends HTMLElement {

    constructor() {
        super();
        this.resize        = this.resize.bind(this);
    }

    connectedCallback() {
        this.__isConnected__ = true;

        let node = this;
        let i=0;
        while (node.parentNode && i<100) { 
            if (node.parentNode.tagName == 'GL-STEPPED-SCROLL') {
                this.$steppedScrollParent = node.parentNode;
                break;
            }
            node = node.parentNode;
            i++;
        }

        if (!this.$steppedScrollParent) {
            console.warn('missing <gl-stepped-scroll> parent node');
            return
        }

        requestAnimationFrame(()=>{
            this.init();
        })

    }

    init() {
        this.$steppedScrollParent.addSection(this);
    }

    disconnectedCallback() {
        this.__isConnected__ = false;
        window.removeEventListener('resize', this.resize);
    }

    resize() {
    }

}



customElements.define('gl-stepped-scroll-section', GLSteppedScrollSection)